// extracted by mini-css-extract-plugin
export var form = "_4g-0";